<template>
  <div class="login">

    <div class="loginHead">
      <img src="../assets/images/loginLogo.png" class="loginHead-img"/>
      <span class="loginHead-title">润泽园区管理系统</span>
    </div>

    <div class="login-wrap">
      <img src="../assets/images/loginCompany.png" class="login-person"/>
      <div class="login-tip"> {{tips}}</div>
      <div v-if="loginStyle" class="login-account">
        <img src="../assets/images/loginQrcode.png" @click='changeLogin' class="login-qrcode"/>
        <el-form :label-position="formLoginPosition" label-width="0" :model="formLogin" status-icon :rules="rules"
                 ref="formLogin" class="login-form">
          <span class="login-account-login">ACCOUNT LOGIN</span>
          <el-form-item prop="tel" class="login-form-item">
            <el-input v-model="formLogin.tel" placeholder="请输入您的手机号码" prefix-icon="el-icon-mobile-phone"></el-input>
          </el-form-item>
          <!-- <div class="login-form-item">
            <i class="icon el-icon-admin-suo"></i>
            <input v-model="formLogin.identifyCode" placeholder="请输入验证码" class="login-input login-identify" />
            <span class="login-code">获取验证码</span>
          </div> -->
          <el-form-item prop="identifyCode" class="login-form-item">
            <el-input class="login-identify" v-model="formLogin.identifyCode" placeholder="请输入验证码"
                      prefix-icon="el-icon-cms-lock"></el-input>
            <el-button class="login-code" :disabled="codeDisable" @click="countDown">{{getCode}}</el-button>
          </el-form-item>
          <el-form-item class="login-form-item">
            <el-button class="form-submit" @click="submitForm('formLogin')">登录</el-button>
          </el-form-item>

        </el-form>
      </div>
      <div v-if="!loginStyle" class="login-appScan">
        <img src="../assets/images/loginMobile.png" class="login-qrcode" @click='changeLogin'/>
        <el-form :label-position="formLoginPosition" label-width="80px" :model="formLogin" status-icon :rules="rules"
                 ref="formLogin" class="login-form">
          <qrCode v-show="qrShow" :qrUrl="qrCodeUrl" :qrStyle="{'width':180,'height':180}" :key="qrCodeUrl"></qrCode>
          <!--<component v-bind:is="item.component" :qrStyle="item.qrStyle" :qrUrl="item.qrUrl" v-for="item in viewItem" :key="item.qrUrl"></component>-->
          <el-button @click="tryScanLogin">模拟</el-button>
          <div class="login-appScan-intro" @click.native="tryScanLogin">请使用登录商家账号的APP扫码登录</div>

        </el-form>
      </div>
    </div>

    <div class="login-bottom">
      <span class="loginBottom-company">加优科技提供技术支持</span>
      <div >
         <a href="http://www.miitbeian.gov.cn/publish/query/indexFirst.action" target="_blank" class="loginBottom-code">冀ICP备18015493号-1</a>
         <div style="color:#fff">/</div>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13100102000014" target="_blank" class="loginBottom-code">公安备案号 13100102000014 </a>
      </div>
    </div>
  </div>
</template>

<script>
  import { validatePwd, validateTel } from '@/utils/validate'
  import { setCookie,getCookie } from '@/utils/common'
  import { code, login, getQrCodeInfo, qrCodeLogin,loginByPhone ,startServer} from '@/api/login'
  import store from '../store'
  import bus from '../utils/EventBus'
  import qrCode from '@/components/QrcodeImg'
  import Stomp from 'stompjs'


  let clock = 60

  export default {
    name: '',
    props: [''],
    components: {
      qrCode
    },
    store,
    data () {
      const validateTelephone = (rule, value, callback) => {
        if (!value) {
          callback(new Error('电话不能为空'))
        } else if (!validateTel(value)) {
          callback(new Error('电话输入不正确'))
        } else {
          callback()
        }
      }
      const validateCode = (rule, value, callback) => {
        if (value) {
          callback()
        } else {
          callback(new Error('验证码不能为空'))
        }
      }
      return {
        loginStyle: true,
        formLoginPosition: 'left',
        formLogin: {
          tel: '',
          identifyCode: ''
        },
        rules: {
          tel: [
            {
              validator: validateTelephone,
              trigger: 'blur'
            }
          ],
          identifyCode: [
            {
              validator: validateCode,
              trigger: 'blur'
            }
          ]
        },
        tips: '请期待扫码登录',
        getCode: '获取验证码',
        codeDisable: false,
        qrCodeUrl: '',
        qrCodeImgData: [],
        client: '',
        qrShow: false,
        currentView: '',
        viewItem: [],
        items: [],
        time:'',
        scanId:'',
        stompClient:'',//stomp客户端
        stompSub:'',//stomp客户端的订阅
      }
    },
// sockets:{
//   connect: function(){
//     console.log('connected')
//
//   },
//   customEmit: function(val){
//     console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
//   },
//
// },
    created() {
      this.getUserPhone();
    },
    mounted () {
      bus.$on('msg', () => {
        this.$message.error('登录失效，请重新登录')
      })

      let userInfo  =  getCookie('userName')
      if(userInfo){
        this.$notify({
          title: '正在登录，请稍后',
          type: 'success',
          duration: 800,
          showClose: false,
        })
        setTimeout(()=> {
          this.$router.push({path: '/main'})
        }, 800)

//        this.saveDataAndRoute(this,userInfo,"正在登录，请稍后")
      }


    },
    methods: {
      getUserPhone() {
      const phone = localStorage.getItem('phone') || '';
      Object.assign(this.formLogin,{tel: phone});
    },
      submitForm (formName) {
        let self = this
        self.$refs[formName].validate(valid => {
          if (valid) {
            login(self.formLogin.tel, self.formLogin.identifyCode).then(res => {
              localStorage.setItem('phone',this.formLogin.tel);
              this.saveDataAndRoute(self,res.data.data)
            }).catch(err => {
              console.log(err)
              self.$notify({
                title: '手机号验证码输入错误',
                type: 'error',
                duration: 800,
                showClose: false,
              })
            })
          } else {
            return false
          }
        })
      },
      resetForm (formName) {
        this.$refs[formName].resetFields()
      },
      showQRCode (message) {
        let data = message
        alert(data)
      },
      changeLogin () {
        if(this.stompSub){
          this.stompSub.unsubscribe();
        }
//        if(this.stompClient){
//          this.stompClient.disconnect(()=>{
//            console.log('sock disconnect');
//          })
//        }
        if (this.loginStyle) {

//          let socket = new SockJS('http://172.20.10.6:8084/endpointWisely') //1
//          let socket = new SockJS('http://test.sps.ddbes.com/endpointWisely') //1
//          this.stompClient = Stomp.over(socket)

          getQrCodeInfo().then(res => {
            this.qrCodeUrl = `http://test.sps.ddbes.com/sps/cms/user/scanQrcode?id=${res.data.id}&time=${res.data.time}&type=3`
            this.qrShow = true
            this.time=res.data.time;
            this.scanId= res.data.id;


            let subId = '/topic/scan/' + res.data.id;


            startServer().then(res=>{
              if(res.status == 200){
                console.log('ok')
                 let socket = io.connect('http://10.0.19.11:8888',{
                   path:'',
                 })
                socket.on('connect',function () {
                  console.log('connected')
                })

//                let socket1 = io.connect('')
                socket.on('advert_data',function () {
                  console.log('connected to server')
                });
              }
            }).catch(error=>{
              console.log(error)
            })

//           socket.on(subId,function (data) {
//             console.log(data)
//           })






//            console.log(this.stompClient)
//            this.stompClient.connect({}, (frame)=> {//3
//              console.log('开始进行连接Connected: ' + frame)
//              this.stompSub = this.stompClient.subscribe('/topic/scan/' + res.data.id, (response) => { //4
//                console.log('get serverinof' + response.body)
////                this.loginByPhoneStr(response.body);
//                let jsonObj = JSON.parse(response.body);
////                this.saveDataAndRoute(this,jsonObj.roleId,jsonObj.userName,jsonObj.roleName,jsonObj.lastLoginTime,jsonObj.listFirstMenu,jsonObj.listsecondMenu,jsonObj.listThreeMenu);
//                this.$confirm(`确认使用账号：${jsonObj.phone}进行登录？`, '提示', {
//                  confirmButtonText: '确定',
//                  cancelButtonText: '取消',
//                  type: 'warning'
//                }).then(() => {
//                    this.scanResult2Login(jsonObj.phone,jsonObj.code);
//                }).catch(() => {
//                  this.$message({
//                    type: 'info',
//                    message: '已取消'
//                  });
//                });
//
//              })
//            })
          })
        }
        this.loginStyle = !this.loginStyle

      },
      saveDataAndRoute(self,data,tipStr){
//        res.data.data.roleId,res.data.data.userName,res.data.data.roleName,res.data.data.lastLoginTime,res.data.data.listFirstMenu,res.data.data.listsecondMenu,res.data.data.listThreeMenu
        setCookie('roleId', data.roleId)
        localStorage.setItem("token",data.token)
        self.$store.commit('SET_USER', data.userName)
        self.$store.commit('SET_ROLE', data.roleName)
        self.$store.commit('SET_LOGINTIME', data.lastLoginTime)

        self.$store.commit('SET_FIRSTMENU', data.listFirstMenu)
        self.$store.commit('SET_SECONDMENU', data.listsecondMenu)
        self.$store.commit('SET_THREEMENU', data.listThreeMenu)
        self.$notify({
          title: tipStr?tipStr:'登录成功',
          type: 'success',
          duration: 800,
          showClose: false,
        })
        setTimeout(function () {
          self.$router.push({path: '/main'})
        }, 800)
      },
      count () {
        let self = this
        if (clock == 0) {
          let tel = self.formLogin.tel
          self.codeDisable = false
          self.getCode = '获取验证码'
          clock = 60

        } else {
          self.codeDisable = true
          self.getCode = '重新发送' + clock + 's'
          clock--
          setTimeout(function () {
            self.count()
          }, 1000)
        }
      },
      countDown () {
        let self = this
        let tel = self.formLogin.tel
        if (validateTel(tel)) {
          //发送验证码
          code(tel).then(res => {
            if (res.code == 1) {
              self.$notify({
              title: '验证码已发送，请注意查看',
              type: 'success',
              duration: 800,
              showClose: false,
            })
             
            } else {
               self.$notify({
                title: res.data.msg,
                type: 'error',
                duration: 800,
                showClose: false,
              })
            }
            
          }).catch(err => {
            console.log(err)
          })
          self.count()
        } else {
          self.$notify({
            title: '手机号码输入有误,请确认',
            type: 'error',
            duration: 800,
            showClose: false,
          })
        }
      },

      scanResult2Login(phone,code){
        loginByPhone(phone,code).then(res=>{
          console.log(res)
          this.saveDataAndRoute(this,res.data.roleId,res.data.userName,res.data.roleName,res.data.lastLoginTime,res.data.listFirstMenu,res.data.listsecondMenu,res.data.listThreeMenu)
        }).catch(error=>{

        })
      },
      //模拟扫码请求
      tryScanLogin(){
        // alert('点击了模拟请求')
        qrCodeLogin('15041199627',this.time,this.scanId).then(res=>{
          console.log(res)
        })
      },
      loginByPhoneStr(phone){
        loginByPhone(phone).then(res=>{
          this.saveDataAndRoute(self,res.data.data.roleId,res.data.data.userName,res.data.data.roleName,res.data.data.lastLoginTime,res.data.data.listFirstMenu,res.data.data.listsecondMenu,res.data.data.listThreeMenu)

        })
      }
    },

  }
</script>

<style scoped lang="scss">
  @import "../style/mixin";
  @import "../style/_variables";

  .login {
    @include flex-column;
    width: 100%;
    height: 100%;
    min-height: 768px;
    background-image: url("../assets/images/loginBg.jpg");
    background-size: 100% 100%;
    justify-content: flex-start;
    // padding-top: 88px;
    > .loginHead {
      margin-top: 80px;
      margin-bottom: 120px;
      @include flex-row;
      > .loginHead-img {
        width: 60px;
        height: 60px;
        margin-right: 8px;
      }
      .loginHead-title {
        font-size: 36px;
        font-weight: bold;
        color: #fff;
      }
    }
    > .login-wrap {
      width: $login-wrap-width;
      height: $login-wrap-height;
      background-image: url("../assets/images/loginBoxBg.png");
      background-size: 100% 100%;
      // background-color: $login-wrapbg-color;
      // border-radius: 5px;
      // box-shadow: 0 2px 10px rgba(224, 228, 11, 0.5);
      margin-right: 20px;
      position: relative;
      > .login-tip {
        position: absolute;
        right: -126px;
        top: 10px;
        width: 136px;
        height: 30px;
        background-image: url('../assets/images/loginTabBg.png');
        background-size: 100% 100%;
        color: #f7f7f7;
        @include flex-column;
        font-size: 12px;
      }
      > .login-person {
        width: 90px;
        height: 90px;
        position: absolute;
        top: -60px;
        left: 50%;
        margin-left: -45px;
      }
      > .login-account {
        width: 100%;
        height: 100%;
        @include flex-row;
        > .login-qrcode {
          position: absolute;
          width: 38px;
          height: 38px;
          right: 10px;
          top: 10px;
          cursor: pointer;
        }
        > .login-form {
          width: 336px;
          margin-top: 28px;
          // padding: 0 40px;
          @include flex-column;
          > .login-account-login {
            font-size: 20px;
            color: #fff;
            margin-bottom: 20px;
          }

          > .login-form-item {
            width: 100%;
            height: 48px;
            margin-bottom: 20px;
            position: relative;
            > .icon {
              position: absolute;
              top: 16px;
              left: 22px;
              width: 18px;
              height: 18px;
            }
            > .login-input {
              // width: 100%;
              width: 286px;
              padding: 0 0 0 50px;
              height: 100%;
              border-radius: 24px;
              border: none;
              margin-bottom: 20px;
              font-size: 16px;
              color: #767676;
            }
          }
        }
      }
      > .login-appScan {
        width: 100%;
        height: 100%;
        @include flex-row;
        > .login-qrcode {
          position: absolute;
          width: 38px;
          height: 38px;
          right: 10px;
          top: 10px;
          cursor: pointer;
        }
        > .login-form {
          @include flex-column;
          margin-top: 20px;
          > .login-scanImg {
            width: 180px;
            height: 180px;
          }
          > .login-appScan-intro {
            margin-top: 20px;
            color: #f7f7f7;
            font-size: 16px;
          }
        }

      }
    }
    > .login-bottom {
      position: fixed;
      bottom: 10px;
      width: 100%;
      @include flex-column;
      > .loginBottom-company {
        font-size: 14px;
        color: #f7f7f7;
      }
      >div{
        >a{
          font-size: 12px;
        color: #f7f7f7;
        }
        
        display: flex;
      }
    }
  }

  // 修改输入框样式
  .login-identify {
    width: 198px !important;

    > .el-input {
      border-radius: 40px;
    }
  }

  .login-code {
    width: 120px;
    background-color: #fff;
    color: #32d08a;
    padding: 14px 20px;
    border-radius: 24px;
    font-size: 14px;
    box-shadow: 1px 1px #474747;
    margin-left: 10px;
    cursor: pointer;
  }

  .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
    color: #c0c4cc;
  }

  .form-submit {
    width: 100%;
    background-color: #32d08a;
    height: 48px;
    color: #fffefe;
    font-size: 16px;
    border-radius: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue